import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage, redirectToBack } from '../../../helpers/history'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

function NavigationMobile({
  groupId,
  isGroupOrganizer,
  isMemberOfGroup,
  isNative,
  isInvite,
  isInvitedByStaff,
  joinAutoApprove,
  hasMemberRole,
  groupAttendPending,
  handleMemberShare,
  addMemberToGroup,
  threeDotsOptions,
  acceptInvitation,
  isSuspended,
  customHandleBack
}) {
  const { t } = useTranslation()

  const handleBack = () => {
    if (customHandleBack) {
      return customHandleBack()
    }
    redirectToBack(isNative)
  }

  return (
    <div className={styles.navigationWrapper}>
      <BackNavigation className={styles.back} theme='lightblue' customHandleBack={handleBack} />
      <div className={`${styles.right} ${isSuspended && 'elementWithSuspendedObject'}`}>
        {isMemberOfGroup && (
          <React.Fragment>
            <button
              className={styles.button}
              onClick={() => redirectToPage(`/0/group/${groupId}/invite-members`, isNative)}>
              <Icon name='add-contact' size='large32' />
            </button>
            <button className={styles.button} onClick={() => redirectToPage(`/0/${groupId}/create-mixr`, isNative)}>
              <Icon name='add-to-cal' size='large32' />
            </button>
          </React.Fragment>
        )}
        {isGroupOrganizer && (
          <button className={styles.button} onClick={() => redirectToPage(`/0/dashboard/group/${groupId}`, isNative)}>
            <Icon name='dashboard' size='large32' />
          </button>
        )}
        {!isMemberOfGroup ? (
          joinAutoApprove ? (
            <React.Fragment>
              <button className={styles.button} onClick={handleMemberShare}>
                <Icon name='send' size='large32' />
              </button>
              {!isInvite && (
                <Button
                  size='large'
                  customStyle={styles.actionBtn}
                  handleClick={addMemberToGroup}
                  text={t('groupHome.header.joinGroup')}
                />
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <button className={styles.button} onClick={handleMemberShare}>
                <Icon name='send' size='large32' />
              </button>
              {!isInvite ? (
                !groupAttendPending ? (
                  <Button
                    size='large'
                    customStyle={styles.actionBtn}
                    handleClick={addMemberToGroup}
                    text={t('groupHome.header.requestJoin')}
                  />
                ) : (
                  <div className={styles.pendingRequestBtn}>{t('groupHome.header.pendingRequest')}</div>
                )
              ) : null}
            </React.Fragment>
          )
        ) : null}
        <ReactMenu options={threeDotsOptions()} buttonIconSize='large32' menuButtonCSS={styles.button} />
      </div>
    </div>
  )
}

export default NavigationMobile
